import { Location } from "history";

const isEditPage = (location: Location): boolean =>
  location.pathname.includes("/edit");
const isCreatePage = (location: Location): boolean =>
  location.pathname.includes("/create");

export { isEditPage, isCreatePage };
